import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,Select,MiniMinusButton} from '../components/Input';
import u from '../utilities/Utilities';
import {Photo} from '../data/Mimetypes';
import moment from 'moment';

export default class SiteList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Work Sites",
        permission:"site",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/site-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-site-entry",
        deleteURL:"/api/delete-site-entries",
        spreadsheetURL:"/api/generate-site-spreadsheet",
        overviewURL:"/api/get-all-site-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"site-list",
        orderByField:"name",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    r={};

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
        staffOptions:[],
        removeIndex:0
    };

    getStaffOptions=()=>{
        this.setState({error:"",loading:true,loadText:"Preparing..."});
        u.post({
            url:"/api/get-staff-options",
            data:{
                siteID:[this.props.content.siteID],
            },
            success:(options)=>{
                this.setState({staffOptions:options,loading:false,step:"add-supervisor"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onAddPhoto=async (filename)=>{
        try{
            const {content}=this.props;
            const response = await u.postAsync({
                url:"/api/reward-item-replace-photo",
                data:{
                    rewardID:content.rewardID,
                    userFilename:this.userFilename,
                    filename:filename,
                }
            });
            this.props.onChange(filename,"image",this.props.index);
            this.setState({loading:false,step:"view"});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onConfirmSupervisor=async ()=>{
        const keys = ['staffID'];
        let data = {};
        for(var i=0; i<keys.length; i++){
            const current = this.r[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data[keys[i]]=current.value;
        }
        this.setState({loading:true,loadText:"Updating..."});
        data.siteID = this.props.content.siteID;
        try{
            const response = await u.postAsync({url:"/api/site-add-supervisor",data:data});
            let {content,index}=this.props;
            content.taskGroup.push(response.data);
            this.props.onChange(content.taskGroup,"taskGroup",index);
            this.setState({step:"view",loading:false});
        }
        catch(e){
            const {error}=u.processError(e);
            this.setState({loading:false,error:error});
        }
    }

    onRemoveRequest=(index)=>{
        this.setState({
            removeIndex:index,
            step:"remove-supervisor"
        });
    }

    onConfirmRemove=()=>{
        this.setState({loading:true,loadText:"Updating..."});
        const {content}=this.props;
        u.post({
            url:"/api/site-remove-supervisor",
            data:{
                siteID:content.siteID,
                entry:content.taskGroup[this.state.removeIndex]
            },
            success:()=>{
                content.taskGroup.splice(this.state.removeIndex,1);
                this.props.onChange(content.taskGroup,"taskGroup",this.props.index);
                this.setState({step:"view",loading:false,error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);
        const {staffOptions,removeIndex}=this.state;

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                    permission={settings.permission}
                                    content={content}
                                    onChange={this.props.onChange}
                                    index={this.props.index}
                                    />

                    <div className='list-table-container'>
                        <h3>Site Supervisors</h3>
                        {
                            (content.taskGroup.length > 0)
                                ?
                                <div className='list-table' style={{maxHeight:"none",margin:"auto"}}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className='remove left'/>
                                                <th>Added On</th>
                                                <th>NRIC/FIN</th>
                                                <th>Name</th>
                                                <th className='right'>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                content.taskGroup.map((item,index)=>{
                                                    return(
                                                        <tr key={index}>
                                                            <td className='remove'>
                                                                <MiniMinusButton enabled={canEdit} index={index} onClick={this.onRemoveRequest}/>
                                                            </td>
                                                            <td>{moment(item.addedOn).format("DD MMM YYYY")}</td>
                                                            <td>{item.nric}</td>
                                                            <td>{item.staffName}</td>
                                                            <td>{item.status}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className='list-placeholder'>
                                    <h3>No Supervisors Added</h3>
                                    <div>Click below to add new entry</div>
                                </div>
                        }
                        {
                            (canEdit)
                                ?
                                <div style={{margin:"20px auto",textAlign:'center'}}>
                                    <TextButton onClick={this.getStaffOptions}>Add Supervisor</TextButton>
                                </div>
                                :
                                null
                        }
                    </div>
                </Step>

                <Step active={this.state.step=="add-attachment"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <h3>Add/Replace Item Photo</h3>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddPhoto}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Photo}
                                  />

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="add-supervisor"}>
                    <div style={{position:"relative",textAlign:"center",fontSize:"14px"}}>
                        <h3>Add Supervisor</h3>
                        <div style={{margin:"20px auto"}}>
                            Supervisors will automatically be assigned to safety shoutout/feedback tasks created by users of the respective site
                        </div>
                        <div className='segment-full-item'>
                            <div className='segment-item-input'>
                                <Select ref={(ref)=>{this.r['staffID']=ref}}
                                        label="Supervisor"
                                        values={{options:staffOptions}}
                                        rules={{required:true}}
                                        />
                            </div>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmSupervisor}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="remove-supervisor"}>
                    <div style={{textAlign:"center",padding:"20px 0"}}>
                        <h2>Confirm removal of supervisor - {content.taskGroup[removeIndex]?.staffName}</h2>
                        <div style={{margin:"10px auto"}}>
                            Note. Respective staff will still be part of the site, but will no longer receive safety shoutout/feedback tasks
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmRemove}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/create-site-entry",
    };

    r={};

    state={
        step:"add",
        entryData:{},
        options:{},
        dormOptions:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        //this.getDormOptions();
        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:"dorm"
            },
            success:(dormOptions)=>{
                dormOptions.unshift({value:"All Users",label:"All Users"});
                dormOptions.unshift({value:"Staff Only",label:"Staff Only"});
                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        })
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                attachments:[],
            },
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onAddAttachment=(url)=>{
        let entryData=this.state.entryData;
        entryData.image=url;
        this.setState({entryData:entryData,step:"add",error:"",loading:false});
    }

    render=()=>{
        const {loading,loadText,step,options,entryData}=this.state;

        const fields=[
            {dataType:"box",label:"Site Name",field:"siteName",rules:{required:true}},
            {dataType:"box",label:"Address",field:"address",rules:{required:true}},
            {dataType:"box",label:"Postal Code",field:"postalCode",rules:{required:true}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}